<footer class="footer footer-dark" [ngStyle]="getColor()">
    <div class="footer-middle">
        <div class="container">
            <div class="row">
                <div class="col-sm-6 col-lg-3 newWidth">
                    <div class="widget widget-about">
                        <img src="{{siteDada?.footerLogo?.url}}" class="footer-logo" alt="Footer Logo">
                        <p class="max-lines-heading"><b>{{footerContent?.heading}}</b></p>
                        <p class="max-lines" [innerHTML]="footerContent?.text" style="color: white; font-size: 1rem;"></p>
                        <div class="social-icons" *ngIf="false">
                            <a href="https://www.instagram.com/localcannabias.416/?hl=en" target="_blank" class="social-icon" title="Instagram" target="_blank"><i class="icon-instagram"></i></a>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-3 newWidth1">
                    <div class="widget footer-link-side">
                        <h4 class="widget-title">Useful Links</h4>

                        <ul class="widget-list">
                            <li *ngFor="let item of usefulLinks"><a href="javascript:;" routerLink="{{item?.link}}">{{item?.name}}</a></li>
<li><a routerLink="sitemap" tabindex="0">Sitemap</a></li>
                        </ul>
                        <h4 class="widget-title" style="margin-top: 30px;margin-bottom: 10px;">Get In Touch</h4>
                        <ul class="Socila-edia-footer">
                            <li *ngIf="siteDada?.instagramLink !=''" style="margin-top: 10px;"><a href="{{siteDada?.instagramLink}}" target="_blank">
                                    <img src="assets/images/instagram.png" alt="" class="insta">
                                </a></li>
                            <li *ngIf="siteDada?.facebookLink !='' " style="margin-top: 10px;"><a href="{{siteDada?.facebookLink}}" target="_blank">
                                    <img src="assets\images\facebook.png" alt="" class="insta">
                                </a>
                            </li>

                            <li *ngIf="siteDada?.twitterLink !=''" style="margin-top: 10px;">
                                <a href="{{siteDada?.twitterLink}}" target="_blank">
                                    <img src="assets/images/twitter.png" alt="" class="insta">
                                </a>
                            </li>

                            <li *ngIf="siteDada?.youtubeLink !=''" style="margin-top: 10px;"><a href="{{siteDada?.youtubeLink}}" target="_blank">
                                    <img src="assets/images/youtube.png" alt="" class="insta">
                                </a></li>

                            <li *ngIf="siteDada?.linkdinLink !=''" style="margin-top: 10px;"><a href="{{siteDada?.linkdinLink}}" target="_blank">
                                    <img src="assets/images/linkedin.png" alt="" class="insta">
                                </a></li>

                            <!-- <li *ngIf="siteDada?.pinterestLink !=''" style="margin-top: 10px;"><a
                                    href="{{siteDada?.pinterestLink}}" target="_blank">
                                    <img src="assets/images/pinterest.png" alt="" class="insta" >
                                </a></li> -->

                            <li *ngIf="siteDada?.snapchatLink !=''" style="margin-top: 10px;"><a href="{{siteDada?.snapchatLink}}" target="_blank">
                                    <img src="assets/images/snapchat.png" alt="" class="insta">
                                </a></li>


                        </ul>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-6 newWidth1">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="widget footer-link-side">
                                <h4 class="widget-title">Contact Information</h4>
        
                                <ul class="widget-list">
                                    <li>
                                        <img src="assets/images/place.png" class="loca-img-new">
        
                                        <span>{{storeInfo?.Address?.AddressLine2}}</span>
                                    </li>
                                    <li>
                                        Call or Text: 
                                        <a [href]="'tel:3652053237'">(365)205-3237</a><br>
                                        <a  [href]="'tel:'+getStoreMObile()">(365) 20 LEAFS (5 3237)</a><br>
                                        <a>Business Phone Number</a>
                                    </li>
                                    <li>
                                        <a href="mailto:{{siteDada?.supportmail}}">{{siteDada?.supportmail}}</a>
                                    </li>
                                </ul>
                                
        
        
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="widget footer-link-side">
                                <h4 class="widget-title">My Account</h4>
        
        
                                <ul class="widget-list" style="margin-bottom: 25px;">
                                    <li *ngIf="!auth"><a style="cursor: pointer;">
                                            <span (click)="openLogin()">Sign In/</span>
                                            <span (click)="openRegister()">Register</span>
                                        </a>
                                    </li>
                                    <li *ngIf="auth"><a (click)="routeToDash()" style="cursor: pointer;">Dashboard</a></li>
                                    <li *ngIf="auth"><a (click)="openLogoutPopUp()" style="cursor: pointer;">Sign
                                            Out</a></li>
        
        
                                </ul>
        
                                <h4 class="widget-title" style="margin-bottom: 10px;">Hours of operations</h4>
                                <p class="max-lines" style="color: white; font-size: 15px;">Open Today : {{checkDeliveryDay()}}</p>
        
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div>
                                <img src="assets/images/authorized-2.png" (click)="openInfoPopup()" class="authorizedImg" alt="Footer Logo">
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>

    <div class="footer-bottom">
        <div class="container">
            <div class="row align-items-center" style="width: 100%;">
                <div class="col-md-{{siteDada?.license ?'4' :'6'}}">
                    <p class="footer-copyright">Powered by<a href="https://www.cannalogic.com/" target="_blank">
                            <img src="assets/images/cannalogic.png" alt="" class="cannalogic-logo"></a>
                    </p>
                </div>
                <div class="col-md-4" *ngIf="siteDada?.license">
                    <div style="display: flex;">
                        <p class="Licenseno" ><a   style="font-size: 13px;">{{siteDada?.licenseHeading}}
                                <br> {{siteDada?.license}}</a></p>
                        <!-- <figure class="footer-payments">
                            <img src="assets/images/card-2.png">
                        </figure> -->
                    </div>

                </div>
                <div class="col-md-{{siteDada?.license ?'4' :'6'}}">
                    <p class="footer-copyright right">
                        {{siteDada?.copyrightText}}
                        <a href="javascript:;" (click)="routeToUrls('privacypolicy')">Privacy Policy</a>
                        &nbsp;&nbsp;/&nbsp;&nbsp;
                        <a href="javascript:;" (click)="routeToUrls('discountpolicy')">Discount Policy</a>
                    </p>
                </div>

            </div>




        </div>
        <div class="container" *ngIf="showBar">
            <div class="textOrder">
                PLEASE TEXT IN YOUR ORDER<br>
                <div class="row">
                    <div class="col-md-6 left">
                        Barrie, Innisfil, Bradford, Newmarket, Aurora <br>
                        <span>647-725-2779</span><br>
                    </div>
                    <div class="col-md-6 right">
                        Vaughan, Whitby, Oshawa <br>
                        <span>647-689-5922</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>


<div class="modal fade" id="footerInfoId" tabindex="-1" aria-labelledby="footerInfoIdLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="footerInfoIdLabel">Cannabis Retail Store Authorization Information</h5>
                <button type="button" class="close" (click)="hideApkModal()" aria-label="Close">
                    <span aria-hidden="true" style="font-size: 30px;">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="padding:15px;">
                <img src="assets/images/infoimg.jpeg" alt="">
            </div>
           
        </div>
    </div>
</div>

<div class="modal fade" id="apkRequestModal" tabindex="-1" aria-labelledby="apkRequestModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="apkRequestModalLabel">APP download request</h5>
                <button type="button" class="close" (click)="hideApkModal()" aria-label="Close">
                    <span aria-hidden="true" style="font-size: 30px;">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="padding:15px;">
                <p><b>Enter your valid phone number and get an {{deviceType}} app link to download by sms</b></p>
                <form *ngIf="apkRequestFormGroup" [formGroup]="apkRequestFormGroup">
                    <div class="row">
                        <div class="form-group col-md-6">
                            <input type="text" class="form-control" formControlName="userName" placeholder="Enter Name">
                        </div>
                        <div class="form-group col-md-6">
                            <input type="number" class="form-control" style="margin-top: 8px;" formControlName="mobileNumber" placeholder="Enter Mobile No.">
                        </div>
                        <div class="form-group col-md-12">
                            <input type="text" class="form-control" formControlName="emailId" placeholder="Enter Email">
                        </div>
                    </div>
                </form><br>
                <p> <b>NOTE:</b> Please make sure not to add 1 before area code and make sure there is no spaces.</p>
                <br>
                <p>Please check you junk or spam folder if you did not receive an email in your inbox. Thank you.</p>
                <br>
                <span style="color: red;">*</span>Trust the app in your settings after downloading.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="hideApkModal()">Close</button>
                <button type="button" class="btn btn-primary" [disabled]='!apkRequestFormGroup?.valid' (click)="submitApkRequest()">Send message
                </button>
            </div>
        </div>
    </div>
</div>